import { assign, createMachine } from 'xstate';

export function createStartupLifecycleMachine({ fetchInitialData, hasValidInitialData, isAuthError }) {
  return createMachine(
    {
      id: 'startup-lifecycle',
      predictableActionArguments: true,
      preserveActionOrder: true,
      initial: 'FETCH_INITIAL_DATA',
      context: {
        data: null,
        error: null,
      },
      states: {
        FETCH_INITIAL_DATA: {
          invoke: {
            id: 'fetch-initial-data',
            src: fetchInitialData,
            onDone: {
              target: 'CHECK_DATA',
              actions: assign({
                data: (_context, event) => event.data,
                error: () => null,
              }),
            },
            onError: {
              target: 'CHECK_ERROR',
              actions: assign({
                error: (_context, event) => event.data,
                data: () => null,
              }),
            },
          },
        },
        CHECK_DATA: {
          always: [
            {
              target: 'NO_ACCOUNTS',
              cond: 'hasNoAccounts',
            },
            {
              target: 'SUCCESS',
              cond: 'isValidData',
            },
            {
              target: 'INVALID_DATA',
            },
          ],
        },
        CHECK_ERROR: {
          always: [
            {
              target: 'AUTH_ERROR',
              cond: 'isAuthErrorResult',
            },
            {
              target: 'ERROR',
            },
          ],
        },
        SUCCESS: {
          type: 'final',
          data: (context) => ({
            status: 'success',
            data: context.data,
          }),
        },
        NO_ACCOUNTS: {
          type: 'final',
          data: (context) => ({
            status: 'no_accounts',
            data: context.data,
          }),
        },
        INVALID_DATA: {
          type: 'final',
          data: (context) => ({
            status: 'invalid_data',
            data: context.data,
          }),
        },
        AUTH_ERROR: {
          type: 'final',
          data: (context) => ({
            status: 'auth_error',
            error: context.error,
          }),
        },
        ERROR: {
          type: 'final',
          data: (context) => ({
            status: 'error',
            error: context.error,
          }),
        },
      },
    },
    {
      guards: {
        hasNoAccounts: (context) => context.data?.me?.accounts?.length === 0,
        isValidData: (context) => hasValidInitialData(context.data),
        isAuthErrorResult: (context) => isAuthError(context.error),
      },
    },
  );
}
